import { Component, inject } from '@angular/core';
import { PermissionService } from '@services/permission.service';
import { DesignSystemModule } from '@compeople-shared/design-system-angular';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { sharedImports } from '../../sharedImports';
import { routes } from '../../app.routes';

@Component({
  selector: 'art-settings-menu',
  templateUrl: './settings-menu.component.html',
  styleUrls: ['./settings-menu.component.scss'],
  imports: [DesignSystemModule, RouterLinkActive, RouterLink, sharedImports],
})
export class SettingsMenuComponent {
  private permissionService = inject(PermissionService);

  private readonly settingsRoute = routes.find((route) => route.path === 'settings');

  navigationRoutes =
    this.settingsRoute?.children?.filter(
      (route) =>
        route.path &&
        [
          'tariff-id',
          'social-insurance-fund',
          'transport-costs',
          'medium-list',
          'fidelio-subcodes',
          'frames-passepartout',
          'test-data',
        ].includes(route.path),
    ) ?? [];

  readonly filteredRoutes = this.permissionService.filterAuthorizedRoutes(this.navigationRoutes);
}
